import React, { Component } from 'react';
import { AppSettings } from '../../constants';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import Multiselect from 'components/Multiselect';
import { PlacesWithStandaloneSearchBox } from 'components/geo-complete/CustomMap';
import PhoneNumberInput from 'components/PhoneNumberInput';
import InputEditAble from 'components/inputEditAble';
import TagsInput from '../../components/tag-input';
import ConfirmationRemoveSuperAdminModal from './confirmation-remove-super-admin-modal';
import '../subcontractor.scss';
import Form from 'components/react-validation/components/form';
import Input from 'components/react-validation/components/input';
import * as Vali from '../../helper/validator-helper';
import Submit from 'components/react-validation/components/submit';

class SubcontractorInformation extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    subcontractorInformation: PropTypes.object,
    onBindingTrade: PropTypes.func,
    tradeSelectList: PropTypes.array,
    onResendInvitation: PropTypes.func,
    onAssignTradeToSubcontractor: PropTypes.func,
    editSubcontractor: PropTypes.func,
    addContactPointSubcontractor: PropTypes.func,
    removeContactPointSubcontractor: PropTypes.func,
    onConfirmRemoveSuperAdmin: PropTypes.func
  };
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      isEditSubcontractorInfo: {},
      isFetchedTrade: false,
      isFetchedContactPoint: false,
      checkTagsValid: false,
      disabledValidateRegex: true,
      originalTrade: [],
      tradeSelected: null,
      location: {},
      subcontractorEmail: !isEmpty(
        props.subcontractorInformation.subcontractorEmail
      )
        ? props.subcontractorInformation.subcontractorEmail.split(',')
        : [props.subcontractorInformation.subcontractorEmail],
      openConfirmationRemoveSuperAdminModal: false,
      openContactPoint: false
    };
  }

  componentDidMount() {
    this.onBindingTrade();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tradeSelectList !== this.props.tradeSelectList) {
      this.setState({ isFetchingTrade: false });
    }

    if (
      nextProps.subcontractorInformation &&
      nextProps.subcontractorInformation.trades
    ) {
      const originalTrade = [];
      nextProps.subcontractorInformation.trades.map(trade => {
        originalTrade.push({
          value: trade.id,
          text: trade.name
        });
      });

      this.setState({
        originalTrade,
        tradeSelected: this.state.tradeSelected === null ? originalTrade.map(item => ({ ...item, isFixed: true })) : this.state.tradeSelected,
        subcontractorEmail: nextProps.subcontractorInformation.subcontractorEmail.split(',').filter(x => x)
      });
    }
  }

  onChangeMap = mapState => {
    const { location } = this.state;
    location.fullLocation = mapState.fullLocation;
    location.city = mapState.city;
    location.state = mapState.state;
    location.postalCode = mapState.postalCode;
    this.setState({ ...location });
  };

  onChangeTags(tags) {
    let tagsValid = [];
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
    tags.map(tag => {
      tagsValid.push(tag);
    });

    const tagsChecked = tagsValid.slice(-1);
    // console.log(tagsChecked, 'TAGS CHECKED');
    const checkedTags = $.map(tagsChecked, $.trim);
    // console.log(checkedTags, 'AFTER REMOVE SPACE');
    const testTags = emailPattern.test(checkedTags);
    const tagValid = $.map(tagsValid, $.trim);
    // console.log(this.state.subcontractorEmail,'email');
    const filter = tagValid.filter(x => emailPattern.test(x) === false);
    // console.log(filter,'filter');
    if (testTags && isEmpty(filter)) {
      this.setState({
        subcontractorEmail: tagValid,
        checkTagsValid: true,
        disabledValidateRegex: true,
        errorMessage: null
      });
    } else {
      this.setState({
        subcontractorEmail: tagValid,
        checkTagsValid: false,
        disabledValidateRegex: false,
        errorMessage: null
      });

    }

  }

  onResendInvitation = () => {
    const { subcontractorId, superAdmin } = this.props.subcontractorInformation;
    this.props.onResendInvitation(subcontractorId, superAdmin.userId);
  };

  onClose = () => {
    this.props.onClose();
  };

  onToggleEdit = () => {
    // console.log(this.state.isEditSubcontractorInfo.trades);
    var tradeSelected = !this.state.isEditSubcontractorInfo.trades ? this.state.originalTrade.map(item => ({ ...item, isFixed: true })) : this.state.tradeSelected;
    this.setState({
      isEditSubcontractorInfo: {
        trades: !this.state.isEditSubcontractorInfo.trades
      },
      tradeSelected
    });
  }

  onToggleEditSubcontractorInfo = field => () => {
    this.setState({
      isEditSubcontractorInfo: {
        [field]: !this.state.isEditSubcontractorInfo[field]
      },
      errorMessage: null,
      subcontractorEmail: this.props.subcontractorInformation.subcontractorEmail.split(
        ','
      ).filter(x => x)
    });
  };

  onSelectedTrade = value => {
    const currentTradeSelected = [
      ...this.props.subcontractorInformation.trades
    ].map(trade => ({
      value: trade.id,
      text: trade.name,
      isFixed: true
    }));
    const newTradeSelected = value.slice(
      this.props.subcontractorInformation.trades.length
    );
    this.setState({
      tradeSelected: [...currentTradeSelected, ...newTradeSelected]
    });
  };

  onBindingTrade = () => {
    this.setState({ isFetchingTrade: true, isFetchedTrade: true });
    this.props.onBindingTrade();
  };

  onSaveTrade = () => {
    if (
      this.state.tradeSelected.length !==
      this.props.subcontractorInformation.trades.length
    ) {
      this.props.onAssignTradeToSubcontractor(
        this.props.subcontractorInformation.subcontractorId,
        this.state.tradeSelected.slice(this.props.subcontractorInformation.trades.length)
      );
      this.onToggleEdit();
    }
  };

  removeContactPoints = (id) => {
    this.props.removeContactPointSubcontractor({
      contactPointId: id,
      subcontractorId: this.props.subcontractorInformation.subcontractorId
    });
    this.setState({
      errorMessage: null
    });
  }

  onRemoveSuperAdmin = () => {
    this.setState({
      openConfirmationRemoveSuperAdminModal: true
    });
  };

  onConfirmRemoveSuperAdmin = () => {
    this.props.onConfirmRemoveSuperAdmin(
      this.onCloseConfirmRemoveSuperAdminModal
    );
  };

  onCloseConfirmRemoveSuperAdminModal = () => {
    this.setState({
      openConfirmationRemoveSuperAdminModal: false
    });
  };

  renderValue = value => {
    if (value === null || value === '') {
      return <span style={{ opacity: 0.4 }}>(Not specified)</span>;
    } else {
      return <strong>{value}</strong>;
    }
  };

  renderTrade = () => {
    const { trades } = this.props.subcontractorInformation;
    let data = [];
    trades.map(trade => data.push(trade.name));
    return <strong>{data.join(', ')}</strong>;
  };

  renderPoints = () => {
    const {contactPoints} = this.props.subcontractorInformation;
    let data = [];
    contactPoints.map(contactPoint => data.push(contactPoint));
    return data.map(item => {
      return <div className='row' style={{marginBottom: 10}} key={item.id}>
        <div className='col-sm-12'>
          <span className='word-break-all' style={{fontWeight: 'bolder', marginRight: 20}}>{`${item.firstName} ${item.lastName}`}</span>
          <span className='word-break-all'>
          ({item.email}) <i
              className='fa fa-trash cancel-icon func-icon'
              onClick={() => this.removeContactPoints(item.id)}
            />
          </span></div></div>;
    });
  }
  renderSiteSuperAdmin = () => {
    const { superAdmin } = this.props.subcontractorInformation;
    if (superAdmin) {
      return (
        <div className='subcontractor-admin'>
          <p style={{ marginBottom: 5, color: '#999999' }}>
            Site's super admin
            <span
              style={{
                textDecoration: 'underline',
                color: 'red',
                marginLeft: 20,
                fontSize: 14,
                cursor: 'pointer'
              }}
              onClick={this.onRemoveSuperAdmin}
            >
              Remove
            </span>
          </p>
          <div className='row subcontractor-block'>
            <div className='field-name'>Full name</div>
            <div className='field-value' style={{ wordBreak: 'break-all' }}>
              {this.renderValue(superAdmin.fullName)}
            </div>
          </div>
          <div className='row subcontractor-block'>
            <div className='field-name'>Email address</div>
            <div className='field-value' style={{ wordBreak: 'break-all' }}>
              {this.renderValue(superAdmin.email)}
            </div>
          </div>
          <div className='row subcontractor-block'>
            <div className='field-name'>Status</div>
            <div className='field-value'>
              <span
                className={`status-super-admin status-super-admin-${
                  superAdmin.status
                }`}
              >
                {superAdmin.statusValue}
              </span>
              {superAdmin.status === 0 && (
                <span
                  className='resend-invitation-btn'
                  onClick={this.onResendInvitation}
                >
                  Resend invitation email
                </span>
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className='subcontractor-admin'>
          <p style={{ marginBottom: 5, color: '#999999' }}>
            Site's super admin
          </p>
          <div className='row subcontractor-block'>
            <div className='col-sm-12' style={{ opacity: 0.4 }}>
              (Not specified)
            </div>
          </div>
        </div>
      );
    }
  };
  //render Contact Points in Subcontractor Information
  renderContactPoints = () => {
    const { contactPoints } = this.props.subcontractorInformation;
    const count = contactPoints.length;
    if (!isEmpty(contactPoints)) {
      return (
        <div className='subcontractor-admin'>
          <p style={{marginBottom: 5, color: '#999999'}}>
          Contact points
            {count < 5 ? <button
              className='btn btn-primary btn-siteone-default'
              style={{padding: '9px 16px', marginLeft: 50}}
              onClick={() => this.setState({openContactPoint: true})}>
              <span className='fa fa-plus icon' />ADD
            </button>
              : <button
                className='btn btn-primary btn-siteone-default'
                style={{padding: '9px 16px', marginLeft: 50}}
                onClick={() => this.setState({openContactPoint: false , errorMessage: 'Maximum 5 contact points allowed'})}>
                <span><span className='fa fa-plus icon' />ADD</span>
              </button>
            }
          </p>
          {!this.state.openContactPoint && this.renderPoints()}
          {this.state.errorMessage && <span className='cls-danger help-block'>
            {this.state.errorMessage}
          </span>
          }
          {this.state.openContactPoint ? this.renderContactPointForm() : null}
        </div>
      );
    } else {
      return (
        <div className='subcontractor-admin'>
          <p style={{marginBottom: 5, color: '#999999'}}>
          Contact points
            {count < 5 ? <button
              className='btn btn-primary btn-siteone-default'
              style={{padding: '9px 16px', marginLeft: 50}}
              onClick={() => this.setState({openContactPoint: true})}>
              <span className='fa fa-plus icon' />ADD
            </button>
              : <button disabled
                className='btn btn-primary btn-siteone-default'
                style={{padding: '9px 16px', marginLeft: 50}}
                onClick={() => this.setState({openContactPoint: true})}>
                <span><span className='fa fa-plus icon' />ADD</span>
              </button>

            }
          </p>
          {!this.state.openContactPoint && <div className='row subcontractor-block'>
            <div className='col-sm-12' style={{ opacity: 0.4 }}>
              (Not specified)
            </div>
          </div>}
          {this.state.openContactPoint ? this.renderContactPointForm() : null}
        </div>
      );
    }
  }

  onValidateEmail = (value) => {
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
    if (emailPattern.test(value.trim())) {
      return true;
    }
    return false;
  }

  onRenderTag(props) {
    let { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other } = props;

    // let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;

    let value = getTagDisplayValue(tag);

    // if (emailPattern.test(value)) { other.className = 'react-tagsinput-tag'; }

    // else { other.className = 'react-tagsinput-tag-error'; }

    if (this.onValidateEmail(value)) { other.className = 'react-tagsinput-tag'; }

    else { other.className = 'react-tagsinput-tag-error'; }

    return <span key={key} {...other}>
      {getTagDisplayValue(tag)}
      {!disabled &&
        <a className={classNameRemove} onClick={() => onRemove(key)} />
      }
    </span>;
  }

  onSubmit = (e) => {
    e.preventDefault();
    const data = this.form.getValues();

    this.props.addContactPointSubcontractor({
      subcontractorId: this.props.subcontractorInformation
        .subcontractorId,
      data: data
    });
    this.setState({
      openContactPoint: false
    });
  }

  renderContactPointForm = () => {
    return <div className='container-fluid'>
      <div style={{padding: 15, border: '1px solid #ccc', marginTop: 15, borderRadius: 2}}>
        <Form
          ref={ref => { this.form = ref; }}
          onSubmit={this.onSubmit}>
          <div className='row'>
            <div className='form-group col-md-6'>
              <label>First name <span className='text-danger'>*</span></label>
              <Input type='text'
                name='firstName'
                ref='firstName'
                placeholder='First name'
                className='form-control'
                max='40'
                maxLength='40'
                validations={[Vali.required, Vali.maxlength]}
              />
            </div>

            <div className='form-group col-md-6'>
              <label>Last name <span className='text-danger'>*</span></label>
              <Input type='text'
                name='lastName'
                ref='lastName'
                placeholder='Last name'
                className='form-control'
                max='40'
                maxLength='40'
                validations={[Vali.required, Vali.maxlength]} />
            </div>

          </div>
          <div className='row'>
            <div className='form-group col-md-6 margin-top-10'>
              <label>Email address <span className='text-danger'>*</span></label>
              <Input type='text'
                name='email'
                ref='email'
                placeholder='Email address'
                className='form-control'
                max='256'
                maxLength='256'
                validations={[Vali.required, Vali.email, Vali.maxlength]} />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 margin-bottom-15 margin-top-15'>
              <a className='btn btn-primary margin-right-5 btn-siteone-default' onClick={() => this.setState({openContactPoint: false})}>Cancel</a>
              <Submit className='btn btn-primary btn-siteone'>Save</Submit>
            </div>
          </div>
        </Form>
      </div>
    </div>;
  }

  updateSubcontractor = (value, isRequired = true) => {
    const { location } = this.state;
    // const {subcontractorEmail} = this.state;
    if (isRequired) {
      if (isEmpty(value) || isEmpty(value[Object.keys(value)[0]])) {
        this.setState({ errorMessage: 'This field is required.' });
      } else {
        this.props.editSubcontractor({
          subcontractorId: this.props.subcontractorInformation
            .subcontractorId,
          data: value
        });
        this.setState({
          isEditSubcontractorInfo: {
            [Object.keys(value)[0]]: !this.state.isEditSubcontractorInfo[
              Object.keys(value)[0]
            ]
          },
          errorMessage: null
        });
      }
    } if (location.fullLocation && !location.state) {
      this.setState({
        errorMessage: 'Invalid location. Please pick a location from the list.'
      });
    } else {
      this.props.editSubcontractor({
        subcontractorId: this.props.subcontractorInformation.subcontractorId,
        data: value
      });
      this.setState({
        isEditSubcontractorInfo: {
          [Object.keys(value)[0]]: !this.state.isEditSubcontractorInfo[
            Object.keys(value)[0]
          ]
        },
        errorMessage: null
      });
    }
  };

  render() {
    const { subcontractorInformation } = this.props;
    const {
      isEditSubcontractorInfo,
      openConfirmationRemoveSuperAdminModal
    } = this.state;
    if (subcontractorInformation) {
      return (
        <Modal
          show={this.props.show}
          className='subcontractor-information-modal'
        >
          <div className='modal-body'>
            {isEditSubcontractorInfo.subcontractorName ? (
              <div
                className='col-sm-12'
                style={{ padding: 0, marginBottom: 15 }}
              >
                <InputEditAble
                  defaultValue={subcontractorInformation.subcontractorName}
                  inputName='subcontractorName'
                  autoFocus
                  onSubmit={this.updateSubcontractor}
                  onCancel={this.onToggleEditSubcontractorInfo(
                    'subcontractorName'
                  )}
                  actionButtonPosition={'bottom'}
                  ignoreOnBlur={true}
                />
              </div>
            ) : (
              <div style={{ marginBottom: 15 }}>
                <span className='title'>
                  {subcontractorInformation.subcontractorName}
                </span>
                <i
                  className='fa fa-pencil subcontractor-edit-trade-btn'
                  onClick={this.onToggleEditSubcontractorInfo(
                    'subcontractorName'
                  )}
                  style={{ transform: 'translateY(-5px)' }}
                />
              </div>
            )}

            <div className='subcontractor-info'>
              <div className='row subcontractor-block'>
                {isEditSubcontractorInfo.subcontractorPhone ? (
                  <div className='col-sm-12'>
                    Company phone <span className='text-danger'> *</span>
                  </div>
                ) : (
                  <div className='field-name'>Company phone</div>
                )}

                {isEditSubcontractorInfo.subcontractorPhone ? (
                  <div className='col-sm-12'>
                    <PhoneNumberInput
                      ref={ref => {
                        this.subcontractorPhone = ref;
                      }}
                      name='subcontractorPhone'
                      defaultValue={subcontractorInformation.subcontractorPhone}
                      editAble
                      isRequired
                      autoFocus
                      ignoreOnBlur
                      actionButtonPosition='top'
                      onSubmit={this.updateSubcontractor}
                      onCancel={this.onToggleEditSubcontractorInfo(
                        'subcontractorPhone'
                      )}
                    />
                    {/*<InputEditAble
                      defaultValue={subcontractorInformation.subcontractorPhone}
                      inputName='subcontractorPhone'
                      autoFocus
                      onSubmit={this.updateSubcontractor}
                      onCancel={this.onToggleEditSubcontractorInfo('subcontractorPhone')}
                      actionButtonPosition={'top'}
                      ignoreOnBlur={true}
                    />*/}
                  </div>
                ) : (
                  <div className='field-value'>
                    {this.renderValue(
                      subcontractorInformation.subcontractorPhone
                    )}
                    <i
                      className='fa fa-pencil subcontractor-edit-trade-btn'
                      onClick={this.onToggleEditSubcontractorInfo(
                        'subcontractorPhone'
                      )}
                    />
                  </div>
                )}
              </div>
              <div className='row subcontractor-block'>
                {isEditSubcontractorInfo.subcontractorEmail ? (
                  <div className='col-sm-12' style={{ marginBottom: 5 }}>
                    Email address <span className='text-danger'> *</span>
                    {this.state.checkTagsValid ? <i
                      className='fa fa-check subcontractor-edit-trade-btn pull-right'
                      onClick={() =>
                        this.updateSubcontractor({
                          subcontractorEmails: this.state.subcontractorEmail
                        })
                      }
                    /> : <i className='fa fa-check subcontractor-edit-trade-btn pull-right'/>}
                    <i
                      className='fa fa-close subcontractor-edit-trade-btn pull-right'
                      onClick={this.onToggleEditSubcontractorInfo(
                        'subcontractorEmail'
                      )}
                    />
                  </div>
                ) : (
                  <div className='field-name'>Email address</div>
                )}

                {isEditSubcontractorInfo.subcontractorEmail ? (
                  <div className='col-sm-12'>
                    <div className='subcontractor'>
                      <TagsInput
                        id='tag-input-email'
                        value={this.state.subcontractorEmail}
                        onChange={tags => {
                          this.onChangeTags(tags, 0);
                        }}
                        inputProps={{ placeholder: 'Type email address' }}
                        addKeys={[9, 13, 188]}
                        addOnBlur
                        // validationRegex={/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/}
                        onlyUnique
                        renderTag={this.onRenderTag.bind(this)}
                      />
                    </div>
                    {this.state.errorMessage && (
                      <span className='cls-danger help-block'>
                        {this.state.errorMessage}
                      </span>
                    )}
                  </div>
                ) : (
                  <div
                    className='field-value'
                    style={{ wordBreak: 'break-all' }}
                  >
                    {this.renderValue(
                      subcontractorInformation.subcontractorEmail
                    )}
                    <i
                      className='fa fa-pencil subcontractor-edit-trade-btn'
                      onClick={this.onToggleEditSubcontractorInfo(
                        'subcontractorEmail'
                      )}
                    />
                  </div>
                )}
              </div>
              <div className='row subcontractor-block'>
                <div className='field-name'>Company domain</div>
                <div className='field-value' style={{ wordBreak: 'break-all' }}>
                  {this.renderValue(subcontractorInformation.domain)}
                </div>
              </div>
              <div className='row subcontractor-block'>
                {isEditSubcontractorInfo.streetAddress ? (
                  <div className='col-sm-12' style={{ marginBottom: 5 }}>
                    Location
                    <i
                      className='fa fa-check subcontractor-edit-trade-btn pull-right'
                      onClick={() =>
                        this.updateSubcontractor(
                          { streetAddress: this.state.location.fullLocation },
                          false
                        )
                      }
                    />
                    <i
                      className='fa fa-close subcontractor-edit-trade-btn pull-right'
                      onClick={this.onToggleEditSubcontractorInfo(
                        'streetAddress'
                      )}
                    />
                  </div>
                ) : (
                  <div className='field-name'>Location</div>
                )}

                {isEditSubcontractorInfo.streetAddress ? (
                  <div className='col-sm-12'>
                    <PlacesWithStandaloneSearchBox
                      className='search-box'
                      defaultValue={subcontractorInformation.streetAddress}
                      ref={c => {
                        this.location = c;
                      }}
                      onChange={this.onChangeMap}
                    />
                    {this.state.errorMessage && (
                      <span className='cls-danger help-block'>
                        {this.state.errorMessage}
                      </span>
                    )}
                  </div>
                ) : (
                  <div className='field-value'>
                    {this.renderValue(subcontractorInformation.streetAddress)}
                    <i
                      className='fa fa-pencil subcontractor-edit-trade-btn'
                      onClick={this.onToggleEditSubcontractorInfo(
                        'streetAddress'
                      )}
                    />
                  </div>
                )}
              </div>
              <div className='row subcontractor-block'>
                {isEditSubcontractorInfo.trades ? (
                  <div className='col-sm-12' style={{ marginBottom: 5 }}>
                    Trades
                    <i
                      className='fa fa-check subcontractor-edit-trade-btn pull-right'
                      onClick={this.onSaveTrade}
                    />
                    <i
                      className='fa fa-close subcontractor-edit-trade-btn pull-right'
                      onClick={this.onToggleEdit}
                    />
                  </div>
                ) : (
                  <div className='field-name'>Trades</div>
                )}

                {isEditSubcontractorInfo.trades ? (
                  <div className='col-sm-12' style={{ marginBottom: -10 }}>
                    <Multiselect
                      placeholder='Select trades...'
                      items={this.props.tradeSelectList}
                      labelKey='text'
                      value={this.state.tradeSelected}
                      onChange={this.onSelectedTrade}
                      onRemote={this.onBindingTrade}
                      isLoading={this.state.isFetchingTrade}
                      errorMessage='This information is required.'
                      clearable={false}
                      removeSelected={true}
                      ref={ref => {
                        this.trades = ref;
                      }}
                    />
                  </div>
                ) : (
                  <div className='field-value'>
                    {this.renderTrade()}
                    <i
                      className='fa fa-pencil subcontractor-edit-trade-btn'
                      onClick={this.onToggleEdit}
                    />
                  </div>
                )}
              </div>
              <div className='row subcontractor-block'>
                <div className='field-name'>Status</div>
                <div className='field-value'>
                  {this.renderValue(subcontractorInformation.clientStatusValue)}
                </div>
              </div>
            </div>
            {this.renderSiteSuperAdmin()}
            { AppSettings.clientTypeValue === 'Builder' && this.renderContactPoints()}
            <div className='row subcontractor-bottom-btn'>
              <div className='col-sm-12'>
                <button
                  className='btn btn-primary btn-siteone-default'
                  onClick={this.onClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>

          {openConfirmationRemoveSuperAdminModal &&
            subcontractorInformation.superAdmin && (
              <ConfirmationRemoveSuperAdminModal
                isOpen={openConfirmationRemoveSuperAdminModal}
                item={subcontractorInformation}
                onClose={this.onCloseConfirmRemoveSuperAdminModal}
                onRemove={this.onConfirmRemoveSuperAdmin}
              />
            )}
        </Modal>
      );
    } else {
      return null;
    }
  }
}

export default SubcontractorInformation;



// WEBPACK FOOTER //
// ./src/Subcontractors/Components/subcontractor-information.js